import { recursiveReviewFields } from './AnswerReviewWorkbench.utils';
import { RecursiveAnswerNode } from './recursiveAnswer';
function simpleLabel(node: RecursiveAnswerNode): string {
  if (node.kind !== 'simple' || node.isNull || node.value === null) {
    return '';
  }
  const values = Array.isArray(node.value) ? node.value : [node.value];
  return values.map(value => {
    if (node.schema.fieldType === 'singleSelect' || node.schema.fieldType === 'multiSelect') {
      return node.schema.options?.find(option => option.value === value)?.label ?? value;
    }
    if (node.schema.fieldType === 'date') {
      return value.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$2/$3/$1');
    }
    // Keep decimal strings exact, including values outside number precision.
    return value;
  }).join(', ').trim();
}
export function recursiveItemSummary(node: RecursiveAnswerNode, position: number) {
  const fallback = `${node.schema.label || 'Item'} ${position}`;
  if (node.isNull) {
    return {
      title: fallback,
      subtitle: ''
    };
  }
  if (node.kind === 'simple') {
    return {
      title: simpleLabel(node) || fallback,
      subtitle: ''
    };
  }
  if (node.kind === 'array') {
    return {
      title: `${node.schema.label || 'Item'} - ${node.items.length} ${node.items.length === 1 ? 'item' : 'items'}`,
      subtitle: ''
    };
  }
  const titleNode = node.properties.find(property => (property.schema.fieldType === 'shortText' || property.schema.fieldType === 'longText') && simpleLabel(property));
  return {
    title: titleNode ? simpleLabel(titleNode) : fallback,
    subtitle: node.properties.filter(property => property !== titleNode).map(simpleLabel).filter(Boolean).slice(0, 2).join(', ')
  };
}

/** Count affected list items once, even when several fields need review.
 * The global summary counts fields instead, so it cannot supply this count.
 */
export function itemsNeedingAttention(node: RecursiveAnswerNode): number {
  if (node.kind !== 'array') {
    return 0;
  }
  return node.items.filter(item => recursiveReviewFields(item.node).some(field => field.currentRevision?.confidence === 'MEDIUM' || field.currentRevision?.confidence === 'NOT_FOUND')).length;
}